












import { Component, Prop, Vue } from 'vue-property-decorator';
import { AnalysisType } from '@/components/analysis/steps/type/AnalysisStepType';

@Component
export default class ElementInterpretationManualBanner extends Vue {
  @Prop({ required: true }) analysisType!: 'walking' | 'running';

  get lang() {
    const currentLang = this.$pdc.doctor!.current.config.lang;
    return currentLang !== 'fr' && currentLang !== 'en' ? 'en' : this.$pdc.doctor!.current.config.lang;
  }
  get manual() {
    return {
      url: this.$pdc.helper!.fromCdn('docs', `manual-interpretation-${this.analysisType}-${this.lang}.pdf`),
      fileName: `interpretation-manual-${this.analysisType}`,
    };
  }
  close() {
    this.$pdc.storage!.setUniversal('dontShowManualInterpretation', true);
  }
}
